export default "__VITE_ASSET__6d7b1eda__"